import React from 'react';
import { Bell, User } from 'lucide-react';

const TopNavigation = () => {
  return (
    <div className="bg-dark text-white px-3 py-2 d-flex justify-content-between align-items-center  ">
      <div className="flex items-center">
        <img src="/static/console/logo.png" alt="Logo" className="me-2" style={{ height: '30px' }} /> {/* Added image */}
        <span className="fw-bold fs-5 me-3">Pantareh Console</span>
        <input
          type="text"
          placeholder="Search..."
          className="px-2 py-1 rounded form-control form-control-sm d-none d-md-block"
        />
      </div>
      <div className="flex items-center ms-3">
        <Bell size={18} className="cursor-pointer" />
        <UserProfile />
      </div>
    </div>
  );
};

const UserProfile = () => {
  return (
    <div className="relative cursor-pointer group">
      <div className="rounded-circle bg-light d-flex align-items-center justify-content-center">
        <User size={16} />
      </div>
      <div className="position-absolute end-0 mt-2 bg-white rounded shadow p-1 dropdown-menu">
        {/* <a href="#" className="dropdown-item">Your Profile</a>
        <a href="#" className="dropdown-item">Settings</a>
        <a href="#" className="dropdown-item">Sign out</a> */}
      </div>
    </div>
  );
};

export default TopNavigation;
